import { DatePicker } from "antd";
import dayjs from "dayjs";
import { useEffect, useRef, useState } from "react";
import 'react-accessible-accordion/dist/fancy-example.css';
import { Modal } from "react-bootstrap";
import { FaSpinner } from "react-icons/fa";
import ReactPaginate from "react-paginate";
import { connect, useDispatch } from "react-redux";
import Select from "react-select";
import { AsyncPaginate } from "react-select-async-paginate";
import { Col, Input, Row, Table } from "reactstrap";
import swal from "sweetalert";
import "../../../css/settings.scss";
import { logout } from "../../../store/actions/AuthActions";
import { api } from "../../../utils/api";
import { exportPageSize, shownItem, transactionTypeList } from "../../../utils/config";
import { digitFormat, downloadExcel } from "../../../utils/function";
import { translate } from "../../../utils/translate";
import LoadingV3 from "../../components/Loading/LoadingV3";
import InfoBox from "../Common/InfoBox";
import NotFound from "../Common/NotFound";
import customSelectStyles from '../SelectStyle';

const { RangePicker } = DatePicker;

const walletList = [
    { label: "CRM Wallet", value: "CRM_WALLET" },
]

const adjustList = [
    { label: "IN", value: "in" },
    { label: "OUT", value: "out" }
]

const Transaction = (props) => {
    const dispatch = useDispatch();
    const [totalResultCount, setTotalResultCount] = useState(0);
    const [productPerpage, setProductPerpage] = useState(10);
    const [pageCount, setPageCount] = useState(0);
    const [loading, setLoading] = useState(false);
    const [pageNumber, setPageNumber] = useState(1);
    const [result, setResult] = useState([]);
    const [trxDetail, setTrxDetail] = useState(null);
    const [trxInfoModal, setTrxInfoModal] = useState(false);
    const [groupEmail, setGroupEmail] = useState('');
    const [statistic, setStatistic] = useState({
        total_adjust: 0,
        total_bonus: 0,
        total_crm_balance: 0,
        total_crm_deposit: 0,
        total_crm_withdraw: 0,
        total_lot_size: 0,
        total_mt5_balance: 0,
        total_mt5_deposit: 0,
        total_mt5_out: 0,
        total_mt5_withdraw: 0,
        total_profit_sharing: 0,
        total_reinvest: 0,
        total_contract_commission: 0,
        total_in_adjust: 0,
        total_out_adjust: 0,
        total_transfer_in: 0,
        total_transfer_out: 0,
    });
    const [email, setEmail] = useState('');
    const [transactionType, setTransactionType] = useState('');
    const [firstLoad, setFirstLoad] = useState(true);
    const [from, setFrom] = useState("");
    const [to, setTo] = useState("");
    const [adjustModal, setAdjustModal] = useState(false);
    const [loadingAdjust, setLoadingAdjust] = useState(false);
    const [loadingExcel, setLoadingExcel] = useState(false);
    const [loadingCustomer, setLoadingCustomer] = useState(false);
    const [formData, setFormData] = useState({
        customer_id: '',
        amount: '',
        wallet_type: 'CRM_WALLET',
        type: '',
        remark: '',
    });
    const [selectedCustomer, setSelectedCustomer] = useState(null)
    let errorsObj = { customer_id: '', email: '', amount: '', wallet_type: '', type: '', remark: '' };
    const [errors, setErrors] = useState(errorsObj);

    const timerRef = useRef(null);

    const changePage = (event) => {
        setPageNumber(event.selected + 1);
        getTransactionList(event.selected + 1);
    }

    useEffect(() => {
        if (firstLoad) {
            getTransactionList();
            setFirstLoad(false);
        }
    }, []);

    useEffect(() => {
        if (!firstLoad) {
            setStatistic({
                total_adjust: 0,
                total_bonus: 0,
                total_crm_balance: 0,
                total_crm_deposit: 0,
                total_crm_withdraw: 0,
                total_lot_size: 0,
                total_mt5_balance: 0,
                total_mt5_deposit: 0,
                total_mt5_out: 0,
                total_mt5_withdraw: 0,
                total_profit_sharing: 0,
                total_reinvest: 0,
                total_contract_commission: 0,
                total_in_adjust: 0,
                total_out_adjust: 0,
                total_transfer_in: 0,
                total_transfer_out: 0,
            })
            setPageNumber(1);
            getTransactionList(1);
        }
    }, [props.lang, from, to, productPerpage, email, transactionType, groupEmail]);

    const handleTimeChange = (e) => {
        const formattedFromDate = e ? dayjs(e[0]).format("YYYY-MM-DD") : '';
        const formattedToDate = e ? dayjs(e[1]).format("YYYY-MM-DD") : '';
        setFrom(formattedFromDate);
        setTo(formattedToDate);
    };

    const getTransactionList = (page = pageNumber) => {
        setLoading(true);
        clearTimeout(timerRef.current);
        timerRef.current = setTimeout(() => {
            let url = api.get_wallet_overview + `?page=${page}&order_by=DESC`;

            if (from && to) {
                url += `&date_start=${from}&date_end=${to}`
            }
            if (productPerpage) {
                url += `&limit=${productPerpage}`
            }
            if (email) {
                url += `&email=${email}`
            }
            if (transactionType) {
                if (transactionType.toLowerCase().includes('commission') || transactionType.toLowerCase().includes('bonus') || transactionType.toLowerCase().includes('profit')) {
                    url += `&transaction_types=${transactionType}&sort_by=wallet_transaction_id`
                } else {
                    url += `&transaction_types=${transactionType}&sort_by=date_added`
                }
            } else {
                url += `&sort_by=date_added`
            }

            if (groupEmail) {
                url += `&group_email=${groupEmail}`
            }
            fetch(url, {
                method: "GET",
                headers: new Headers({
                    "Content-Type": "application/json",
                    "Accept-Language": props.lang,
                    "Authorization": "Bearer " + props.auth.auth.access_token
                }),
            })
                .then(response => response.json())
                .then(responseJson => {
                    setTimeout(() => {
                        setLoading(false);
                    }, 1000);
                    if (responseJson.status === "success") {
                        setStatistic(responseJson.data.statistic);
                        setResult(responseJson.data.results);
                        var pageCount = Math.ceil(responseJson.data.total_results / productPerpage)
                        setPageCount(pageCount);
                        setTotalResultCount(responseJson.data.total_results)
                    } else {
                        if (responseJson.status === 'error' && responseJson.message.toLowerCase() === 'token expired') {
                            dispatch(logout(props.history, 'login'));
                        }
                        console.log("error", responseJson.message);
                    }
                }).catch(error => {
                    console.error("error", error);
                });
        }, 1000);
    }

    const loadOptions = async (searchQuery, loadedOptions, { page }) => {
        let resultPerPage = 10
        if (!loadingCustomer) {
            try {
                const response = await fetch(`${api.get_customers + '?page=' + page + '&limit=5&email=' + searchQuery}`, {
                    method: 'GET',
                    headers: {
                        "Content-Type": "application/json",
                        "Accept-Language": props.lang,
                        "Authorization": "Bearer " + props.auth.auth.access_token
                    }
                });

                const responseJson = await response.json();
                if (responseJson.status !== "success") {
                    throw new Error('Failed to fetch: ' + responseJson);
                }

                const options = responseJson.data.results.map(item => ({
                    value: item.customer_id ? item.customer_id : '',
                    label: `${item.email} (${item.full_name ? item.full_name : item.nick_name})`
                }));
                let totalPage = Math.ceil(responseJson.data.total_results / resultPerPage);

                const hasMore = page < totalPage;
                setLoadingCustomer(false)
                return {
                    options,
                    hasMore,
                    additional: {
                        page: page + 1,
                    },
                };
            } catch (error) {
                console.error('Error fetching data:', error);
                setLoadingCustomer(false)
                return {
                    options: [],
                    hasMore: false,
                    additional: {
                        page,
                    },
                };
            }
        }
    }

    const handleAddFormChange = (event) => {
        event.preventDefault();
        const fieldName = event.target.getAttribute('name');
        let fieldValue = event.target.value;
        const newFormData = { ...formData };
        newFormData[fieldName] = fieldValue;
        setFormData(newFormData);
    }

    const handleOptionSelectedForm = async (e, type) => {
        const { value } = e;
        const newFormData = { ...formData };
        newFormData[type] = value;
        setFormData(newFormData);
    }

    const submit = () => {
        let check = true;
        const errorMsg = { ...errorsObj };
        let newFormData = { ...formData };

        if (selectedCustomer.length === 0) {
            errorMsg.customer_id = 'This field is required.';
            check = false;
        } else {
            newFormData.customer_id = selectedCustomer.value;
        }

        if (!formData.amount) {
            errorMsg.amount = 'This field is required.';
            check = false;
        } else {
            newFormData.amount = Number(newFormData.amount);
        }
        if (!formData.type) {
            errorMsg.type = 'This field is required.';
            check = false;
        }

        setErrors(errorMsg);
        if (check) {
            delete newFormData.wallet_type;
            setLoadingAdjust(true);
            fetch(api.wallet_adjust, {
                method: "POST",
                headers: new Headers({
                    "Content-Type": "application/json",
                    "Accept-Language": props.lang,
                    "Authorization": "Bearer " + props.auth.auth.access_token

                }),
                body: JSON.stringify(newFormData)
            })
                .then(response => response.json())
                .then(responseJson => {
                    setLoadingAdjust(false);
                    if (responseJson.status === "success") {
                        swal(translate(props.lang, 'Success'), responseJson.message, "success");
                        getTransactionList();
                        closeAdjustModal()
                    } else {
                        if (responseJson.status === 'error' && responseJson.message.toLowerCase() === 'token expired') {
                            dispatch(logout(props.history, 'login'));
                        }
                        if (responseJson.data && typeof responseJson.data.error === 'object') {
                            let apiErrorMsg = { ...errorsObj };
                            let popupMessage = [];
                            Object.keys(responseJson.data.error).map((key) => {
                                apiErrorMsg[key] = responseJson.data.error[key];
                                popupMessage.push(responseJson.data.error[key])
                            })
                            setErrors(apiErrorMsg);
                            swal(translate(props.lang, "Error"), popupMessage.join('\n'), "error");
                        } else {
                            swal(translate(props.lang, "Error"), responseJson.message, "error");
                        }
                    }
                }).catch(error => {
                    console.error("error", error);
                });
        }
    }

    const handleChangeCustomer = (e) => {
        setSelectedCustomer(e);
    }

    const resetForm = () => {
        setFormData({
            customer_id: '',
            email: '',
            amount: '',
            wallet_type: '',
            type: '',
            remark: '',
        })
        setErrors(errorsObj);
    }

    const closeAdjustModal = () => {
        setAdjustModal(false)
        resetForm();
    }

    const openAdjustModal = () => {
        setAdjustModal(true)
    }

    const formatData = (data) => {
        let newData = [];
        data.forEach(entry => {
            let formattedData = {
                "Date": entry.date_added,
                "Email": entry.email,
                "Name": entry.full_name ? entry.full_name : entry.nick_name,
                "Transaction Type": entry.transaction_type_text,
                "Action": entry.type_text,
                "Amount": Number(entry.amount).toLocaleString('en-US'),
                "Description": entry.remark,
            };
            newData.push(formattedData);
        });
        return newData;
    }

    const exportExcel = () => {
        const totalPagesCount = Math.ceil(totalResultCount / exportPageSize);
        let processData = [];
        let totaldata = 0;
        if (totalPagesCount > 0) {
            setLoadingExcel(true);
            for (let pageCount = 1; pageCount <= totalPagesCount; pageCount++) {
                let url = api.get_wallet_overview + `?page=${pageCount}&order_by=DESC&limit=${exportPageSize}`;

                if (from && to) {
                    url += `&date_start=${from}&date_end=${to}`
                }
                if (email) {
                    url += `&email=${email}`
                }
                if (transactionType) {
                    if (transactionType.toLowerCase().includes('commission') || transactionType.toLowerCase().includes('bonus') || transactionType.toLowerCase().includes('profit')) {
                        url += `&transaction_types=${transactionType}&sort_by=wallet_transaction_id`
                    } else {
                        url += `&transaction_types=${transactionType}&sort_by=date_added`
                    }
                } else {
                    url += `&sort_by=date_added`
                }

                if (groupEmail) {
                    url += `&group_email=${groupEmail}`
                }

                fetch(url, {
                    method: "GET",
                    headers: new Headers({
                        "Content-Type": "application/json",
                        "Accept-Language": props.lang,
                        "Authorization": "Bearer " + props.auth.auth.access_token
                    }),
                })
                    .then(response => response.json())
                    .then(responseJson => {
                        if (responseJson.status === "success") {
                            totaldata = responseJson.data.total_results;
                            processData = processData.concat(formatData(responseJson.data.results));
                        } else {
                            if (responseJson.status === 'error' && responseJson.message.toLowerCase() === 'token expired') {
                                dispatch(logout(props.history, 'login'));
                            }
                            swal(translate(props.lang, "Error"), responseJson.message, "error");
                        }
                        if (processData.length === totaldata) {
                            downloadExcel(processData, 'wallet_transaction')
                            setLoadingExcel(false)
                        }
                    }).catch(error => {
                        console.error("error", error);
                    });

            }
        } else {
            swal(translate(props.lang, "Error"), translate(props.lang, "No data to export"), "error");
        }
    }

    const openTrxInfoModal = (info) => {
        setTrxDetail(info);
        setTrxInfoModal(true);
    }

    const closeTrxInfoModal = () => {
        setTrxDetail(null);
        setTrxInfoModal(false)
    }

    return (
        <>
            <div className='pb-5 wallet'>
                <Row className="mx-0 px-0 mt-3 mt-md-0">
                    <Col lg={12} md={12} sm={12} xs={12} className="px-0">
                        <div className="whiteContainer px-md-4 py-md-4 p-2">
                            <div className="infoContainer">
                                <div className="px-md-3 py-md-3 px-2 py-4">
                                    <Row className="mx-0 px-0 align-items-center">
                                        <Col lg={6} md={6} sm={12} xs={12}>
                                            <span className="infoTitle">{translate(props.lang, "Wallet Transaction List")}</span>
                                        </Col>
                                        <Col lg={6} md={6} sm={12} xs={12}></Col>
                                        <Col lg={4} md={6} sm={12} xs={12} className="mt-3">
                                            <InfoBox
                                                boxLabel={translate(props.lang, "CRM In (Deposit)")}
                                                boxValue={statistic && statistic.total_crm_deposit ? Number(statistic.total_crm_deposit).toLocaleString('en-US', digitFormat) : '0'}
                                                loading={false}
                                            />
                                        </Col>
                                        <Col lg={4} md={6} sm={12} xs={12} className="mt-3">
                                            <InfoBox
                                                boxLabel={translate(props.lang, "CRM Out (Withdraw)")}
                                                boxValue={statistic && statistic.total_crm_withdraw ? Number(statistic.total_crm_withdraw).toLocaleString('en-US', digitFormat) : '0'}
                                                loading={false}
                                            />
                                        </Col>
                                        <Col lg={4} md={6} sm={12} xs={12} className="mt-3">
                                            <InfoBox
                                                boxLabel={translate(props.lang, "Wallet Balance")}
                                                boxValue={statistic && statistic.total_crm_balance ? Number(statistic.total_crm_balance).toLocaleString('en-US', digitFormat) : '0'}
                                                loading={false}
                                            />
                                        </Col>
                                        <Col lg={4} md={6} sm={12} xs={12} className="mt-3">
                                            <InfoBox
                                                boxLabel={translate(props.lang, "MT5 In (Deposit)")}
                                                boxValue={statistic && statistic.total_mt5_deposit ? Number(statistic.total_mt5_deposit).toLocaleString('en-US', digitFormat) : '0'}
                                                loading={false}
                                            />
                                        </Col>
                                        <Col lg={4} md={6} sm={12} xs={12} className="mt-3">
                                            <InfoBox
                                                boxLabel={translate(props.lang, "MT5 Out (Withdraw)")}
                                                boxValue={statistic && statistic.total_mt5_withdraw ? Number(statistic.total_mt5_withdraw).toLocaleString('en-US', digitFormat) : '0'}
                                                loading={false}
                                            />
                                        </Col>
                                        <Col lg={4} md={6} sm={12} xs={12} className="mt-3">
                                            <InfoBox
                                                boxLabel={translate(props.lang, "MT5 Balance")}
                                                boxValue={statistic && statistic.total_mt5_balance ? Number(statistic.total_mt5_balance).toLocaleString('en-US', digitFormat) : '0'}
                                                loading={false}
                                            />
                                        </Col>
                                        <Col lg={4} md={6} sm={12} xs={12} className="mt-3">
                                            <InfoBox
                                                boxLabel={translate(props.lang, "Total Bonus")}
                                                boxValue={statistic && statistic.total_bonus ? Number(statistic.total_bonus).toLocaleString('en-US', digitFormat) : '0'}
                                                loading={false}
                                            />
                                        </Col>
                                        <Col lg={4} md={6} sm={12} xs={12} className="mt-3">
                                            <InfoBox
                                                boxLabel={translate(props.lang, "Profit Sharing") + '(100%)'}
                                                boxValue={statistic && statistic.total_profit_sharing ? Number(statistic.total_profit_sharing).toLocaleString('en-US', digitFormat) : '0'}
                                                loading={false}
                                            />
                                        </Col>
                                        <Col lg={4} md={6} sm={12} xs={12} className="mt-3">
                                            <InfoBox
                                                boxLabel={translate(props.lang, "Re-Invest")}
                                                boxValue={statistic && statistic.total_reinvest ? Number(statistic.total_reinvest).toLocaleString('en-US', digitFormat) : '0'}
                                                loading={false}
                                            />
                                        </Col>
                                        <Col lg={4} md={6} sm={12} xs={12} className="mt-3">
                                            <InfoBox
                                                boxLabel={translate(props.lang, "Total In (Adjust)")}
                                                boxValue={statistic && statistic.total_in_adjust ? Number(statistic.total_in_adjust).toLocaleString('en-US', digitFormat) : '0'}
                                                loading={false}
                                            />
                                        </Col>
                                        <Col lg={4} md={6} sm={12} xs={12} className="mt-3">
                                            <InfoBox
                                                boxLabel={translate(props.lang, "Total Out (Adjust)")}
                                                boxValue={statistic && statistic.total_out_adjust ? Number(statistic.total_out_adjust).toLocaleString('en-US', digitFormat) : '0'}
                                                loading={false}
                                            />
                                        </Col>
                                        {/* <Col lg={4} md={6} sm={12} xs={12} className="mt-3">
                                            <InfoBox
                                                boxLabel={translate(props.lang, "Adjust (Dummy Account)")}
                                                boxValue={statistic && statistic.total_adjust ? Number(statistic.total_adjust).toLocaleString('en-US') : '0'}
                                                loading={false}
                                            />
                                        </Col> */}
                                        <Col lg={4} md={6} sm={12} xs={12} className="mt-3">
                                            <InfoBox
                                                boxLabel={translate(props.lang, "MT5 Out (Member)")}
                                                boxValue={statistic && statistic.total_mt5_out ? Number(statistic.total_mt5_out).toLocaleString('en-US') : '0'}
                                                loading={false}
                                            />
                                        </Col>
                                        <Col lg={4} md={6} sm={12} xs={12} className="mt-3">
                                            <InfoBox
                                                boxLabel={translate(props.lang, "Total Transfer (In)")}
                                                boxValue={statistic && statistic.total_transfer_in ? Number(statistic.total_transfer_in).toLocaleString('en-US') : '0'}
                                                loading={false}
                                            />
                                        </Col>
                                        <Col lg={4} md={6} sm={12} xs={12} className="mt-3">
                                            <InfoBox
                                                boxLabel={translate(props.lang, "Total Transfer (Out)")}
                                                boxValue={statistic && statistic.total_transfer_out ? Number(statistic.total_transfer_out).toLocaleString('en-US') : '0'}
                                                loading={false}
                                            />
                                        </Col>
                                    </Row>
                                </div>
                            </div>
                            <div className="tableContainer">
                                <Row className="align-items-center mt-3">
                                    <>
                                        <Col lg={4} md={4} sm={12} xs={12} className="mb-3">
                                            <div className="groupLabel-input">
                                                <div className="input-group">
                                                    <Input
                                                        type="text"
                                                        placeholder={translate(props.lang, "Personal (Search By Email)")}
                                                        className="form-control input-transparent py-1 px-3"
                                                        onChange={e => setEmail(e.target.value ? e.target.value : '')}
                                                        value={email}
                                                    />
                                                </div>
                                            </div>
                                        </Col>
                                        <Col lg={4} md={4} sm={12} xs={12} className="mb-3">
                                            <div className="groupLabel-input">
                                                <div className="input-group">
                                                    <Input
                                                        type="text"
                                                        placeholder={translate(props.lang, "Group (Search By Email)")}
                                                        className="form-control input-transparent py-1 px-3"
                                                        onChange={e => setGroupEmail(e.target.value ? e.target.value : '')}
                                                        value={groupEmail}
                                                    />
                                                </div>
                                            </div>
                                        </Col>
                                        <Col lg={4} md={4} sm={12} xs={12} className="mb-3">
                                            <RangePicker
                                                className="w-100 mt-3 mt-md-0 input-transparent"
                                                placeholder={[
                                                    translate(props.lang, "From"),
                                                    translate(props.lang, "To"),
                                                ]}
                                                onChange={(e) => handleTimeChange(e)}
                                            />
                                        </Col>
                                        <Col lg={4} md={4} sm={12} xs={12} className="mb-3">
                                            <div className="input-group-select select-placeholder-center">
                                                <div className="d-flex align-items-center">
                                                    <Select
                                                        options={
                                                            transactionTypeList.length > 0 ? transactionTypeList.map((item, i) => ({ key: i, value: item.value, label: translate(props.lang, item.label) })) : [{ value: '', label: translate(props.lang, "No options available") }]
                                                        }
                                                        placeholder={translate(props.lang, "Transaction Type")}
                                                        className="input-transparent w-100 text-capitalize"
                                                        styles={customSelectStyles}
                                                        isSearchable={false}
                                                        isClearable={true}
                                                        value={
                                                            transactionTypeList.filter(item => item.value === transactionType).length > 0 ?
                                                                (transactionTypeList.filter(item => item.value === transactionType).map((item, i) => ({ value: item.value, label: translate(props.lang, item.label), key: i })))
                                                                : null
                                                        }
                                                        name="transactionType"
                                                        onChange={(e) => setTransactionType(e ? e.value : '')}
                                                    />
                                                </div>
                                            </div>
                                        </Col>
                                        <Col lg={4} md={4} sm={12} xs={12} className="mb-3">
                                            <div className="input-group-select select-placeholder-center">
                                                <Select
                                                    options={
                                                        shownItem.length > 0 ? shownItem.map((item, i) => ({ key: i, value: item.value, label: item.label })) : [{ value: '', label: translate(props.lang, "No options available") }]
                                                    }
                                                    placeholder={translate(props.lang, "Result Per Page")}
                                                    className="input-transparent w-100 text-capitalize"
                                                    styles={customSelectStyles}
                                                    value={shownItem && shownItem.find(option => option.value === productPerpage)}
                                                    name="productPerpage"
                                                    isSearchable={false}
                                                    onChange={(e) => setProductPerpage(e.value ? e.value : '')}
                                                />
                                            </div>
                                        </Col>
                                    </>
                                    <Col lg={4} md={4} sm={12} xs={12} className="mb-3">
                                        <button className="primary-btn px-4 py-2 text-center mx-auto w-100" onClick={() => openAdjustModal()}>
                                            <span className={`btnText`}>{translate(props.lang, "Wallet Adjust")}</span>
                                        </button>
                                    </Col>
                                </Row>

                            </div>
                            <>
                                <Table responsive className="w-100 table-list text-center position-relative">
                                    <thead>
                                        <tr>
                                            <th className={`font-weight-600 font-16 text-black text-center`}>{translate(props.lang, "Transaction Date")}</th>
                                            <th className={`font-weight-600 font-16 text-black text-center`}>{translate(props.lang, "Email")}</th>
                                            <th className={`font-weight-600 font-16 text-black text-center`}>{translate(props.lang, "Name")}</th>
                                            <th className={`font-weight-600 font-16 text-black text-center`}>{translate(props.lang, "Action")}</th>
                                            <th className={`font-weight-600 font-16 text-black text-center`}>{translate(props.lang, "Amount")}</th>
                                            <th className={`font-weight-600 font-16 text-black text-center`}>{translate(props.lang, "Transaction Type")}</th>
                                            <th className={`font-weight-600 font-16 text-black text-center`}>{translate(props.lang, "Status")}</th>
                                            <th className={`font-weight-600 font-16 text-black text-center`}>{translate(props.lang, "Transaction Desc")}</th>
                                            <th className={`font-weight-600 font-16 text-black text-center`}>{translate(props.lang, "Details")}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {loading ? (
                                            <tr>
                                                <td colSpan={9}>
                                                    <LoadingV3 theme='dark' />
                                                </td>
                                            </tr>
                                        ) : (
                                            result.length > 0 ? (
                                                result.map((item, i) => (
                                                    <tr role="row" className={`${i % 2 === 0 ? 'even' : 'odd'}`} key={i}>
                                                        <td className={`font-weight-500 font-16 text-center text-black lh-base`}>{item.date_added ? item.date_added : ''}</td>
                                                        <td className={`font-weight-500 font-16 text-center lh-base`}>{item.email}</td>
                                                        <td className={`font-weight-500 font-16 text-center lh-base`}>{item.full_name ? item.full_name : item.nick_name}</td>
                                                        <td className={`font-weight-500 font-16 text-center text-capitalize`}>{item.type_text ? item.type_text.toLowerCase() : ''}</td>
                                                        <td className={`font-weight-500 font-16 text-center`}>{item.amount ? Number(item.amount).toLocaleString('en-US', digitFormat) : ''}</td>
                                                        <td className={`font-weight-500 font-16 text-center`}>{item.transaction_type_text ? item.transaction_type_text : ''}</td>
                                                        <td className={`font-weight-500 font-16 text-center status ${item.status.toLowerCase()}`}>{item.status ? translate(props.lang, "wallet_" + item.status.toLowerCase()) : ''}</td>
                                                        <td className={`font-weight-500 font-16 text-center`}>{item.transaction_type === 'WITHDRAW' ? `${translate(props.lang, "Receive")} ${item.remark[item.remark.length - 1]}` : item.remark ? item.remark : '-'}</td>
                                                        <td className={`font-weight-500 font-16 text-center`} style={{ minWidth: '150px' }}>
                                                            <div className="copyBox py-2 px-2 d-inline-block text-center cursor-pointer" onClick={() => openTrxInfoModal(item)}>
                                                                <span className="d-block font-weight-500 text-white">{translate(props.lang, "View Details")}</span>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr role="row" className={`even`}>
                                                    <td colSpan={9}>
                                                        <NotFound />
                                                    </td>
                                                </tr>
                                            )
                                        )}
                                    </tbody>
                                </Table>
                                <div className="pt-4">
                                    {!loading && result.length > 0 ? (
                                        <div className="my-3">
                                            <ReactPaginate
                                                previousLabel={"<"}
                                                nextLabel={">"}
                                                pageCount={pageCount}
                                                forcePage={pageNumber - 1}
                                                onPageChange={changePage}
                                                containerClassName={"pagination font-weight-400 font-16 text-uppercase text-grey-2"}
                                                previousLinkClassName={"pagination__previouslink pagination-arrow text-black"}
                                                nextLinkClassName={"pagination__nextlink pagination-arrow text-black"}
                                                disabledClassName={"pagination__link--disabled text-muted"}
                                                activeClassName={"pagination__link--active text-black"}
                                                marginPagesDisplayed={window.innerWidth > 667 ? 3 : 1}
                                            />
                                        </div>
                                    ) : null}
                                </div>
                            </>

                        </div>
                    </Col>
                </Row>
            </div>
            <Modal className="fade bgImgModal" show={adjustModal} centered>
                <Modal.Header className="border-0 pt-4 pb-2">
                    <div className="d-flex w-100 align-items-center">
                        <div className="w-75"></div>
                        <div className="w-25 text-end cursor-pointer" onClick={() => closeAdjustModal()} >
                            <svg width="20" height="20" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M26 3L3 26" stroke="#777777" strokeWidth="5" strokeLinecap="round" />
                                <path d="M3.00928 3L26.0093 26" stroke="#777777" strokeWidth="5" strokeLinecap="round" />
                            </svg>
                        </div>
                    </div>
                </Modal.Header>
                <Modal.Body className="border-0 px-3">
                    <div className='modalBody'>
                        <div className="px-0 px-md-4">
                            <Row className="justify-content-start px-0 mx-0">
                                <Col lg={12} md={12} sm={12} xs={12} className="my-3">
                                    <div className="text-center mb-3">
                                        <span className="font-weight-600 font-30 text-black">{translate(props.lang, "Wallet Adjust")}</span>
                                    </div>
                                </Col>
                                <Col lg={12} md={12} sm={12} xs={12} className="px-0">
                                    <span className={`font-16 font-weight-600 text-grey-2`}>{translate(props.lang, "Email")}</span>
                                    <div className={`input-group-select mb-1 ${errors.customer_id ? 'errorBorder' : ''}  mt-1`}>
                                        <AsyncPaginate
                                            placeholder={translate(props.lang, "Enter Member Email")}
                                            debounceTimeout={300} // Optional: wait 300ms after typing stops to make API request
                                            loadOptions={loadOptions} // Function to load options asynchronously
                                            additional={{
                                                page: 1, // Initial page
                                            }}
                                            className="input-transparent w-100"
                                            classNamePrefix="customSelect"
                                            styles={customSelectStyles}
                                            value={selectedCustomer}
                                            closeMenuOnSelect={true}
                                            onChange={(e) => handleChangeCustomer(e)}
                                        />
                                    </div>
                                    <span className="font-weight-400 font-14 errorTextRed ms-0">{translate(props.lang, errors.customer_id)}</span>
                                </Col>
                                <Col lg={12} md={12} sm={12} xs={12} className="mt-3 px-0">
                                    <span className={`font-16 font-weight-600 text-grey-2`}>{translate(props.lang, "Amount")}</span>
                                    <div className={`groupLabel-input mb-1 ${errors.amount ? 'errorBorder' : ''} mt-1`}>
                                        <div className="input-group">
                                            <Input
                                                type='number'
                                                step={0.01}
                                                onWheel={event => event.currentTarget.blur()}
                                                name="amount"
                                                placeholder={translate(props.lang, "Enter Amount")}
                                                className="form-control input-transparent py-1 px-3"
                                                value={formData.amount}
                                                autoComplete="off"
                                                id="amount"
                                                onChange={e => handleAddFormChange(e)}
                                            />
                                        </div>
                                    </div>
                                    <span className="font-weight-400 font-14 errorTextRed ms-0">{translate(props.lang, errors.amount)}</span>
                                </Col>
                                <Col lg={12} md={12} sm={12} xs={12} className="mt-3 px-0">
                                    <span className={`font-16 font-weight-600 text-grey-2`}>{translate(props.lang, "Wallet Type")}</span>
                                    <div className={`input-group-select mb-1 ${errors.wallet_type ? 'errorBorder' : ''}  mt-1`}>
                                        <Select
                                            options={
                                                walletList.length > 0 ? walletList.map((item, i) => ({ key: i, value: item.value, label: translate(props.lang, item.label) })) : [{ value: '', label: translate(props.lang, "No options available") }]
                                            }
                                            placeholder={translate(props.lang, "Wallet Type")}
                                            className="input-transparent w-100 text-capitalize"
                                            styles={customSelectStyles}
                                            isSearchable={false}
                                            classNamePrefix="customSelect"
                                            value={
                                                formData.wallet_type ? walletList.filter(item => item.value === formData.wallet_type).map((item) => ({ value: item.value, label: translate(props.lang, item.label) })) : ''
                                            }
                                            onChange={(e) => handleOptionSelectedForm(e, "wallet_type")}
                                        />
                                    </div>
                                    <span className="font-weight-400 font-14 errorTextRed ms-0">{translate(props.lang, errors.wallet_type)}</span>
                                </Col>
                                <Col lg={12} md={12} sm={12} xs={12} className="mt-3 px-0">
                                    <span className={`font-16 font-weight-600 text-grey-2`}>{translate(props.lang, "Action")}</span>
                                    <div className={`input-group-select mt-1 mb-1 ${errors.type ? 'errorBorder' : ''}`}>
                                        <Select
                                            options={
                                                adjustList.length > 0 ? adjustList.map((item, i) => ({ key: i, value: item.value, label: translate(props.lang, item.label) })) : [{ value: '', label: translate(props.lang, "No options available") }]
                                            }
                                            placeholder={translate(props.lang, "Select Action")}
                                            className="input-transparent w-100 text-capitalize"
                                            styles={customSelectStyles}
                                            isSearchable={false}
                                            classNamePrefix="customSelect"
                                            value={
                                                formData.type ? adjustList.filter(item => item.value === formData.type).map((item) => ({ value: item.value, label: translate(props.lang, item.label) })) : ''
                                            }
                                            onChange={(e) => handleOptionSelectedForm(e, "type")}
                                        />
                                    </div>
                                    <span className="font-weight-400 font-14 errorTextRed ms-0">{translate(props.lang, errors.type)}</span>
                                </Col>
                                <Col lg={12} md={12} sm={12} xs={12} className="mt-3 px-0">
                                    <span className={`font-16 font-weight-600 text-grey-2`}>{translate(props.lang, "Remark")}</span>
                                    <div className={`groupLabel-input mt-1 mb-1 ${errors.remark ? 'errorBorder' : ''}`}>
                                        <div className="input-group">
                                            <Input
                                                type="text"
                                                placeholder={translate(props.lang, "Enter Remark")}
                                                className="form-control input-transparent py-1 px-3"
                                                onChange={e => handleAddFormChange(e)}
                                                name="remark"
                                                value={formData.remark}
                                            />
                                        </div>
                                    </div>
                                    <span className="font-weight-400 font-14 errorTextRed ms-0">{translate(props.lang, errors.remark)}</span>
                                </Col>
                                <Col lg={12} md={12} sm={12} xs={12} className="mt-4 px-0">
                                    <button className="primary-btn px-4 py-1 text-center mx-auto w-100" onClick={() => submit()} disabled={loadingAdjust}>
                                        <span className={`font-weight-600 font-20 line-height-30 text-white`}>
                                            {loadingAdjust ? <FaSpinner className="fa-spin" /> : translate(props.lang, "Submit")}
                                        </span>
                                    </button>
                                </Col>
                            </Row>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

            <Modal className="fade modalColorBg" show={trxInfoModal} centered>
                <Modal.Header className="border-0 py-4">
                    <div className="d-flex w-100 align-items-center">
                        <div className="w-75"></div>
                        <div className="w-25 text-end cursor-pointer" onClick={() => closeTrxInfoModal()} >
                            <svg width="20" height="20" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M26 3L3 26" stroke="#777777" strokeWidth="5" strokeLinecap="round" />
                                <path d="M3.00928 3L26.0093 26" stroke="#777777" strokeWidth="5" strokeLinecap="round" />
                            </svg>
                        </div>
                    </div>
                </Modal.Header>
                <Modal.Body className="border-0 px-3 pt-0">
                    <div className='modalBody'>
                        <div>
                            <div className="text-center mb-4">
                                <span className="font-weight-600 font-30 text-black">{translate(props.lang, "Details")}</span>
                            </div>
                            {trxDetail ? (
                                <Row className="mx-0 px-0">
                                    <Col lg={12} md={12} xs={12} sm={12} className="mb-3">
                                        <Row className="px-0 mx-0 justify-content-start align-items-start">
                                            <Col lg={12} md={12} sm={12} xs={12} className="mb-2">
                                                <div>
                                                    <span className="font-weight-400 font-16 line-height-26 text-black op6 break-all-word">{translate(props.lang, "Date & Time")}</span>
                                                </div>
                                            </Col>
                                            <Col lg={12} md={12} sm={12} xs={12}>
                                                <div>
                                                    <span className="font-weight-600 font-18 line-height-26 text-black text-capitalize break-all-word">{trxDetail.date_added}</span>
                                                </div>
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col lg={12} md={12} xs={12} sm={12} className="mb-3">
                                        <Row className="px-0 mx-0 justify-content-start align-items-start">
                                            <Col lg={12} md={12} sm={12} xs={12} className="mb-2">
                                                <div>
                                                    <span className="font-weight-400 font-16 line-height-26 text-black op6 break-all-word">{translate(props.lang, "Assets Type")}</span>
                                                </div>
                                            </Col>
                                            <Col lg={12} md={12} sm={12} xs={12}>
                                                <div>
                                                    <span className="font-weight-600 font-18 line-height-26 text-black break-all-word">{trxDetail.transaction_type_text}</span>
                                                </div>
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col lg={12} md={12} xs={12} sm={12} className="mb-3">
                                        <Row className="px-0 mx-0 justify-content-start align-items-start">
                                            <Col lg={12} md={12} sm={12} xs={12} className="mb-2">
                                                <div>
                                                    <span className="font-weight-400 font-16 line-height-26 text-black op6 break-all-word">{translate(props.lang, "Action")}</span>
                                                </div>
                                            </Col>
                                            <Col lg={12} md={12} sm={12} xs={12}>
                                                <div>
                                                    <span className="font-weight-600 font-18 line-height-26 text-black break-all-word text-capitalize">{trxDetail.type_text.toLowerCase()}</span>
                                                </div>
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col lg={12} md={12} xs={12} sm={12} className="mb-3">
                                        <Row className="px-0 mx-0 justify-content-start align-items-start">
                                            <Col lg={12} md={12} sm={12} xs={12} className="mb-2">
                                                <div>
                                                    <span className="font-weight-400 font-16 line-height-26 text-black op6 break-all-word">{translate(props.lang, "Amount")}</span>
                                                </div>
                                            </Col>
                                            <Col lg={12} md={12} sm={12} xs={12}>
                                                <div>
                                                    <span className="font-weight-600 font-18 line-height-26 text-black break-all-word">{Number(trxDetail.amount).toLocaleString('en-US', digitFormat)}</span>
                                                </div>
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col lg={12} md={12} xs={12} sm={12} className="mb-3">
                                        <Row className="px-0 mx-0 justify-content-start align-items-start">
                                            <Col lg={12} md={12} sm={12} xs={12} className="mb-2">
                                                <div>
                                                    <span className="font-weight-400 font-16 line-height-26 text-black op6 break-all-word">{translate(props.lang, "Status")}</span>
                                                </div>
                                            </Col>
                                            <Col lg={12} md={12} sm={12} xs={12}>
                                                <div>
                                                    <span className={`font-weight-600 font-18 line-height-26 break-all-word status d-inline-block ${trxDetail.status.toLowerCase()}`}> {translate(props.lang, "wallet_" + trxDetail.status.toLowerCase())}</span>
                                                </div>
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col lg={12} md={12} xs={12} sm={12} className="mb-3">
                                        <Row className="px-0 mx-0 justify-content-start align-items-start">
                                            <Col lg={12} md={12} sm={12} xs={12} className="mb-2">
                                                <div>
                                                    <span className="font-weight-400 font-16 line-height-26 text-black op6 break-all-word">{translate(props.lang, "Description")}</span>
                                                </div>
                                            </Col>
                                            <Col lg={12} md={12} sm={12} xs={12}>
                                                <div>
                                                    {trxDetail.transaction_type === 'WITHDRAW' ? (
                                                        <>
                                                            <span className="mb-1 d-block font-weight-600 font-18 line-height-26 text-black break-all-word break-white-space lh-base overflow-text-anywhere">{translate(props.lang, "Request wallet withdraw")}</span>
                                                            <table>
                                                                <tr>
                                                                    <td><span className="font-weight-600 font-18 line-height-26 text-black break-all-word break-white-space lh-base overflow-text-anywhere">{translate(props.lang, "Doc No.")}</span></td>
                                                                    <td>
                                                                        <span className="font-weight-600 font-18 line-height-26 text-black break-all-word break-white-space lh-base overflow-text-anywhere px-2">:</span>
                                                                        <span className="font-weight-600 font-18 line-height-26 text-black break-all-word break-white-space lh-base overflow-text-anywhere">{trxDetail.remark[0] ? trxDetail.remark[0] : '-'}</span>
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td><span className="font-weight-600 font-18 line-height-26 text-black break-all-word break-white-space lh-base overflow-text-anywhere">{translate(props.lang, "Submit Amount")}</span></td>
                                                                    <td>
                                                                        <span className="font-weight-600 font-18 line-height-26 text-black break-all-word break-white-space lh-base overflow-text-anywhere px-2">:</span>
                                                                        <span className="font-weight-600 font-18 line-height-26 text-black break-all-word break-white-space lh-base overflow-text-anywhere">{trxDetail.remark[1] ? trxDetail.remark[1] : '-'}</span>
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td><span className="font-weight-600 font-18 line-height-26 text-black break-all-word break-white-space lh-base overflow-text-anywhere">{translate(props.lang, "Fee")}</span></td>
                                                                    <td>
                                                                        <span className="font-weight-600 font-18 line-height-26 text-black break-all-word break-white-space lh-base overflow-text-anywhere px-2">:</span>
                                                                        <span className="font-weight-600 font-18 line-height-26 text-black break-all-word break-white-space lh-base overflow-text-anywhere">{trxDetail.remark[2] ? trxDetail.remark[2] : '-'}</span>
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td>
                                                                        <span className="font-weight-600 font-18 line-height-26 text-black break-all-word break-white-space lh-base overflow-text-anywhere">{translate(props.lang, "Receive Amount")}</span>
                                                                    </td>
                                                                    <td>
                                                                        <span className="font-weight-600 font-18 line-height-26 text-black break-all-word break-white-space lh-base overflow-text-anywhere px-2">:</span>
                                                                        <span className="font-weight-600 font-18 line-height-26 text-black break-all-word break-white-space lh-base overflow-text-anywhere">{trxDetail.remark[3] ? trxDetail.remark[3] : '-'}</span>
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td>
                                                                        <span className="font-weight-600 font-18 line-height-26 text-black break-all-word break-white-space lh-base overflow-text-anywhere">{translate(props.lang, "Remark")}</span>
                                                                    </td>
                                                                    <td>
                                                                        <span className="font-weight-600 font-18 line-height-26 text-black break-all-word break-white-space lh-base overflow-text-anywhere px-2">:</span>
                                                                        <span className="font-weight-600 font-18 line-height-26 text-black break-all-word break-white-space lh-base overflow-text-anywhere">{trxDetail.order_remark ? trxDetail.order_remark : '-'}</span>
                                                                    </td>
                                                                </tr>
                                                            </table>
                                                        </>
                                                    ) : trxDetail.transaction_type === "TRANSFER_FROM_MT5" ? (
                                                        trxDetail.remark_arr && JSON.parse(trxDetail.remark_arr).length > 1 ? (
                                                            <>
                                                                <span className="mb-1 d-block font-weight-600 font-18 line-height-26 text-black break-all-word break-white-space lh-base overflow-text-anywhere">{translate(props.lang, "MT5 Transfer to Wallet")}</span>
                                                                <table>
                                                                    <tr>
                                                                        <td><span className="font-weight-600 font-18 line-height-26 text-black break-all-word break-white-space lh-base overflow-text-anywhere">{translate(props.lang, "Submit Amount")}</span></td>
                                                                        <td>
                                                                            <span className="font-weight-600 font-18 line-height-26 text-black break-all-word break-white-space lh-base overflow-text-anywhere px-2">:</span>
                                                                            <span className="font-weight-600 font-18 line-height-26 text-black break-all-word break-white-space lh-base overflow-text-anywhere">{JSON.parse(trxDetail.remark_arr)[0] ? JSON.parse(trxDetail.remark_arr)[0] : '-'}</span>
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td><span className="font-weight-600 font-18 line-height-26 text-black break-all-word break-white-space lh-base overflow-text-anywhere">{translate(props.lang, "Day Count")}</span></td>
                                                                        <td>
                                                                            <span className="font-weight-600 font-18 line-height-26 text-black break-all-word break-white-space lh-base overflow-text-anywhere px-2">:</span>
                                                                            <span className="font-weight-600 font-18 line-height-26 text-black break-all-word break-white-space lh-base overflow-text-anywhere">{JSON.parse(trxDetail.remark_arr)[1] ? JSON.parse(trxDetail.remark_arr)[1] : '-'}</span>
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td><span className="font-weight-600 font-18 line-height-26 text-black break-all-word break-white-space lh-base overflow-text-anywhere">{translate(props.lang, "Handling Fee")}</span></td>
                                                                        <td>
                                                                            <span className="font-weight-600 font-18 line-height-26 text-black break-all-word break-white-space lh-base overflow-text-anywhere px-2">:</span>
                                                                            <span className="font-weight-600 font-18 line-height-26 text-black break-all-word break-white-space lh-base overflow-text-anywhere">{JSON.parse(trxDetail.remark_arr)[2] ? JSON.parse(trxDetail.remark_arr)[2] : '-'}</span>
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>
                                                                            <span className="font-weight-600 font-18 line-height-26 text-black break-all-word break-white-space lh-base overflow-text-anywhere">{translate(props.lang, "Receive Amount")}</span>
                                                                        </td>
                                                                        <td>
                                                                            <span className="font-weight-600 font-18 line-height-26 text-black break-all-word break-white-space lh-base overflow-text-anywhere px-2">:</span>
                                                                            <span className="font-weight-600 font-18 line-height-26 text-black break-all-word break-white-space lh-base overflow-text-anywhere">{JSON.parse(trxDetail.remark_arr)[3] ? JSON.parse(trxDetail.remark_arr)[3] : '-'}</span>
                                                                        </td>
                                                                    </tr>
                                                                </table>
                                                            </>
                                                        ) : (
                                                            <span className="font-weight-600 font-18 line-height-26 text-black break-all-word break-white-space lh-base overflow-text-anywhere">{trxDetail.remark}</span>
                                                        )
                                                    ) : (
                                                        <span className="font-weight-600 font-18 line-height-26 text-black break-all-word break-white-space lh-base overflow-text-anywhere">{trxDetail.remark}</span>
                                                    )}
                                                </div>
                                            </Col>
                                        </Row>
                                    </Col>
                                    {trxDetail.transaction_type === 'WITHDRAW' ? (
                                        <Col lg={12} md={12} xs={12} sm={12} className="mb-3">
                                            <Row className="px-0 mx-0 justify-content-start align-items-start">
                                                <Col lg={12} md={12} sm={12} xs={12} className="px-0">
                                                    {trxDetail.withdrawal_remark.map((item, i) => (
                                                        <div key={i}>
                                                            <Row className="px-0 mx-0 justify-content-start align-items-start">
                                                                <Col lg={12} md={12} sm={12} xs={12} className="mb-2">
                                                                    <div>
                                                                        <span className="font-weight-400 font-16 line-height-26 text-black op6 break-all-word">{translate(props.lang, "Txn Hash")}</span>
                                                                    </div>
                                                                </Col>
                                                                <Col lg={12} md={12} sm={12} xs={12}>
                                                                    <div>
                                                                        <span className={`font-weight-600 font-18 line-height-26 text-black break-all-word`}><a className="link-hash" href={item.transaction_url} target="_blank">{item.transaction_hash}</a></span>
                                                                    </div>
                                                                </Col>
                                                            </Row>
                                                        </div>
                                                    ))}
                                                </Col>
                                            </Row>
                                        </Col>
                                    ) : null}
                                </Row>
                            ) : null}
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

const mapStateToProps = state => {
    const { auth, i18n } = state;
    return {
        lang: i18n.lang,
        auth: auth,
    }
}

export default connect(mapStateToProps)(Transaction);